module.exports = __webpack_public_path__ + "cd1964ae2f85e3578d6dded4e3926dd2.svg";